import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Breadcrumb from "../../Breadcrumb/Breadcrumb";
import { useParams } from "react-router-dom";
import useRequest from "../../../hooks/useRequest";
import { Link, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { FaFileDownload } from "react-icons/fa";
const DOWNLOAD_URL = `https://api.sortyfy.com/api/vendor/order/downloadPdfInvoice?orderId`;
export const upperCaseByWord = (str) => {
  if (str) {
    const words = str.split(" ");

    for (let i = 0; i < words.length; i++) {
      words[i] = words[i][0]?.toUpperCase() + words[i]?.substr(1) + " ";
    }
    return words;
  }
  return str;
};

const OrderDetail = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const { request: requestDetail, response: requestResponse } = useRequest();
  const [orderDetail, setOrderDetail] = useState({});
  const { id: lastID } = useParams();
  const [ids, setIds] = useState(queryParams.get("outletId"));
  useEffect(() => {
    requestDetail(`POST`, `admin/order/getOrderDetailTesting`, {
      bookingId: lastID?.split("?")[0],
    });

    // setIds(lastID ? lastID : "");
  }, []);

  useEffect(() => {
    if (requestResponse) {
      setOrderDetail(requestResponse?.data);
    }
  }, [requestResponse]);

  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb
            title="Order Details"
            links={[
              { to: "/", name: "Home" },
              {
                to: `/booking-orders`,
                // to: `/vendor/orders/${queryParams.get("outletId")}`,
                name: "Orders",
              },
            ]}
          />
        </div>
        <div className="col-md-12">
          <div className="ms-panel">
            {/* <div className="ms-panel-header header-mini">
              <div className="d-flex justify-content-between">
                <h6>Order</h6>
                <h6>#135178</h6>
              </div>
            </div> */}
            <div className="ms-panel-body">
              {/* Invoice To */}
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className="invoice-address">
                    <h3>Order: </h3>
                    {/* <h5>{upperCase(orderDetails?.userName)}</h5> */}
                    <p>
                      Order Status :
                      {orderDetail?.bookingStatus && (
                        <span
                          className={
                            orderDetail.bookingStatus === "decline"
                              ? "badge badge-dark ml-1"
                              : orderDetail.bookingStatus === "accepted"
                              ? "badge badge-success ml-1"
                              : "badge badge-primary ml-"
                          }
                        >
                          {""}
                          {upperCaseByWord(
                            orderDetail.bookingStatus == "cancel"
                              ? "Cancelled"
                              : orderDetail.bookingStatus == "completed" &&
                                orderDetail.isVerified == "no"
                              ? "Upcoming"
                              : orderDetail.bookingStatus
                          )}
                        </span>
                      )}
                    </p>
                    <p className="mb-0">{orderDetail?.address}</p>
                    <p className="mb-0">{orderDetail?.city}</p>
                    <p className="mb-0">{orderDetail?.country}</p>
                    {orderDetail?.menu?.image &&
                      orderDetail?.bookingStatus == "completed" && (
                        <p className="mb-0">
                          {" "}
                          <img
                            className="image-display"
                            src={orderDetail?.menu?.image}
                          />
                        </p>
                      )}
                  </div>
                </div>
                <div className="col-md-6 text-md-right">
                  <ul className="invoice-date">
                    <li>Booking Date : {orderDetail?.bookingDateTime}</li>
                    {/* <li>Due Date : Sunday, April 19 2021</li> */}
                  </ul>
                </div>
              </div>
              {/* Invoice Table */}
              <div className="ms-invoice-table table-responsive mt-5">
                <table className="table table-hover text-right thead-light">
                  <thead>
                    <tr className="text-capitalize">
                      <th className="text-center w-5">id</th>
                      <th className="text-left">Outlet</th>
                      <th className="text-left">Guest Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="text-center">{1}</td>
                      <td className="text-left">{orderDetail?.outletName}</td>
                      <td>
                        {orderDetail?.userName
                          ? upperCaseByWord(orderDetail.userName)
                          : ""}
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan={2}>Total Guests:</td>
                      <td>{orderDetail?.totalGuests}</td>
                    </tr>
                  </tfoot>
                </table>
                <br />

                {orderDetail &&
                orderDetail?.promotionDetail &&
                Object.keys(orderDetail.promotionDetail).length ? (
                  <>
                    <h3>Promotion Detail: </h3>
                    <div className="ms-invoice-table table-responsive mt-5">
                      <table className="table table-hover text-right thead-light">
                        <thead>
                          <tr className="text-capitalize">
                            <th className="text-center w-5">id</th>
                            <th className="text-left">Title</th>
                            <th className="text-left">Price (per person)</th>
                            <th className="text-left">Discount(%)</th>
                            <th className="text-left">Image</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="text-center">{1}</td>
                            <td className="text-left">
                              {orderDetail?.promotionDetail?.promotionTitle
                                ? upperCaseByWord(
                                    orderDetail?.promotionDetail?.promotionTitle
                                  )
                                : ""}
                            </td>
                            <td className="text-left">
                              {orderDetail?.promotionDetail?.promotionPrice
                                ? orderDetail?.promotionDetail?.promotionPrice
                                : ""}
                            </td>
                            <td className="text-left">
                              {orderDetail?.promotionDetail?.promotionDiscount
                                ? orderDetail?.promotionDetail
                                    ?.promotionDiscount
                                : ""}
                            </td>
                            <td className="text-left">
                              {orderDetail?.promotionDetail?.promotionImage ? (
                                <img
                                  src={
                                    orderDetail?.promotionDetail?.promotionImage
                                  }
                                  alt={
                                    orderDetail?.promotionDetail?.promotionImage
                                  }
                                />
                              ) : (
                                ""
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </>
                ) : (
                  ""
                )}

                <>
                  {orderDetail ? (
                    <>
                      {orderDetail?.orderDetail?.map((orderValue, i) => (
                        <div className="ms-invoice-table table-responsive mt-5">
                          <h5>
                            {" "}
                            Order # : {orderValue?.orderNumber}{" "}
                            <a
                              href={`${DOWNLOAD_URL}=${orderValue?.orderId}`}
                              target="_blank"
                            >
                              <FaFileDownload fontSize={"30px"} />
                            </a>
                          </h5>
                          <table className="table table-hover text-right thead-light">
                            <caption>Menus</caption>
                            <thead>
                              <tr className="text-capitalize">
                                <th className="text-center w-5">id</th>
                                <th className="text-left">description</th>
                                <th className="text-left">qty</th>

                                <th className="text-left">total</th>
                              </tr>
                            </thead>
                            <tbody>
                              {orderValue &&
                                orderValue?.menuItem?.map((menu, index) => (
                                  <tr>
                                    <td className="text-center">{index + 1}</td>
                                    <td className="text-left">{menu?.name}</td>
                                    <td>{menu?.quantity}</td>
                                    <td>{menu?.amount}</td>
                                  </tr>
                                ))}
                            </tbody>
                            {orderValue?.type != "table" ? (
                              <tfoot>
                                <tr>
                                  <td colSpan={3}>Gross Amount: </td>
                                  <td>{orderValue?.grossAmount}</td>
                                </tr>
                                <tr>
                                  <td colSpan={3}>
                                    <ul>
                                      <li>{orderValue?.outletDiscount}</li>
                                      <li>
                                        {" "}
                                        Applied {orderValue?.sortyfyDiscount}%
                                        Sortyfy Discount
                                      </li>
                                    </ul>
                                  </td>

                                  <td>{orderValue?.discountAmount}</td>
                                </tr>
                                <tr>
                                  <td colSpan={3}>Amount After Discount: </td>
                                  <td>{orderValue?.amountAfterDiscount}</td>
                                </tr>
                                <tr>
                                  <td colspan={3}>
                                    <table className="table table-hover text-right thead-light">
                                      <tbody>
                                        {orderValue?.taxDetail &&
                                          orderValue?.taxDetail?.map(
                                            (menu, index) => (
                                              <tr>
                                                <td>
                                                  {menu?.title} {menu?.amount}%
                                                </td>
                                              </tr>
                                            )
                                          )}
                                      </tbody>
                                    </table>
                                  </td>
                                  <td>
                                    <table className="table table-hover text-right thead-light">
                                      <tbody>
                                        {orderValue?.taxDetail &&
                                          orderValue?.taxDetail?.map(
                                            (menu, index) => (
                                              <tr>
                                                <td>{menu?.charge}</td>
                                              </tr>
                                            )
                                          )}
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>

                                <tr>
                                  <td colSpan={3}>Paybale Amount: </td>
                                  <td>{orderValue?.amountAfterTax}</td>
                                </tr>

                                <td colspan={3}>
                                  <table className="table table-hover text-right thead-light">
                                    <tbody>
                                      {orderValue?.extraChargesGuest &&
                                        orderValue?.extraChargesGuest?.map(
                                          (menu, index) => (
                                            <tr>
                                              <td>Guest {menu?.title} :</td>
                                            </tr>
                                          )
                                        )}
                                    </tbody>
                                  </table>
                                </td>

                                <td>
                                  <table className="table table-hover text-right thead-light">
                                    <tbody>
                                      {orderValue?.extraChargesGuest &&
                                        orderValue?.extraChargesGuest?.map(
                                          (menu, index) => (
                                            <tr>
                                              <td>{menu?.charge}</td>
                                            </tr>
                                          )
                                        )}
                                    </tbody>
                                  </table>
                                </td>
                                <tr>
                                  <td colSpan={3}>
                                    Redeemed {orderValue?.redeemPoint} Points:{" "}
                                  </td>
                                  <td>{orderValue?.redeemAmount}</td>
                                </tr>

                                <tr>
                                  <td colSpan={3}> Table Booking :</td>
                                  <td>{orderValue?.tableAmount}</td>
                                </tr>
                                <tr>
                                  <td colSpan={3}>Paid by guest: </td>
                                  <td>{orderValue?.netAmount}</td>
                                </tr>
                                <tr>
                                  <td colSpan={3}> Sortyfy Commission :</td>
                                  <td>{orderValue?.sortyfyCommission}</td>
                                </tr>

                                <td colspan={3}>
                                  <table className="table table-hover text-right thead-light">
                                    <tbody>
                                      {orderValue?.extraChargesVendor &&
                                        orderValue?.extraChargesVendor?.map(
                                          (menu, index) => (
                                            <tr>
                                              <td>Vendor {menu?.title} :</td>
                                            </tr>
                                          )
                                        )}
                                    </tbody>
                                  </table>
                                </td>

                                <td>
                                  <table className="table table-hover text-right thead-light">
                                    <tbody>
                                      {orderValue?.extraChargesVendor &&
                                        orderValue?.extraChargesVendor?.map(
                                          (menu, index) => (
                                            <tr>
                                              <td>{menu?.charge}</td>
                                            </tr>
                                          )
                                        )}
                                    </tbody>
                                  </table>
                                </td>
                                <tr>
                                  <td colSpan={3}> Final Outlet Payout :</td>
                                  <td>{orderValue?.vendorPaybleAmount}</td>
                                </tr>
                                {/* <tr>
                                <td colSpan={3}> Final Paid Amount:</td>
                                <td>{orderDetail?.menu?.netAmount}</td>
                              </tr> */}
                              </tfoot>
                            ) : (
                              <tfoot>
                                <tr>
                                  <td colSpan={3}> Table Booking Amount:</td>
                                  <td>{orderValue?.netAmount}</td>
                                </tr>
                              </tfoot>
                            )}
                          </table>
                          {orderValue?.type != "table" && (
                            <table className="table table-hover text-right thead-light">
                              <thead>
                                <tr>
                                  <th colSpan={2}>Transaction Details</th>
                                  <td colSpan={2}></td>
                                </tr>
                              </thead>
                              <tr>
                                <td colSpan={3}>Transaction Id: </td>
                                <td>{orderValue?.transactionId}</td>
                              </tr>
                              <tr>
                                <td colSpan={3}>Transaction Date: </td>
                                <td>{orderValue?.transactionDate}</td>
                              </tr>
                              <tr>
                                <td colSpan={3}>Transaction Status: </td>
                                <td>{orderValue?.transactionStatus}</td>
                              </tr>
                            </table>
                          )}
                        </div>
                      ))}
                    </>
                  ) : (
                    "No menu items found"
                  )}
                  <br />
                  <br />
                </>

                {orderDetail?.addonMenu?.length ? (
                  <>
                    <h3>Addon Menus: </h3>

                    {orderDetail?.addonMenu.map((addMenu, i) => {
                      return (
                        <div className="ms-invoice-table table-responsive mt-5">
                          <h5>
                            Order # :{" "}
                            <b> {orderDetail?.addonMenu?.[i]?.orderNumber}</b>
                            <a
                              href={`${DOWNLOAD_URL}=${addMenu?.orderId}`}
                              target="_blank"
                            >
                              <FaFileDownload fontSize={"30px"} />
                            </a>
                          </h5>
                          <table className="table table-hover text-right thead-light">
                            <caption>Menus</caption>
                            <thead>
                              <tr className="text-capitalize">
                                <th className="text-center w-5">id</th>
                                <th className="text-left">description</th>
                                <th className="text-left">qty</th>

                                <th className="text-left">total</th>
                              </tr>
                            </thead>
                            <tbody>
                              {addMenu.menuItem?.length &&
                                addMenu.menuItem?.map((m, index) => (
                                  <tr>
                                    <td className="text-center">{index + 1}</td>
                                    <td className="text-left">{m?.name}</td>
                                    <td>{m?.quantity}</td>
                                    <td>{m?.amount}</td>
                                  </tr>
                                ))}
                            </tbody>
                            <tfoot>
                              {/* <tr>
                                <td colSpan={3}>Gross Amount: </td>
                                <td>{addMenu.grossAmount}</td>
                              </tr>
                              <tr>
                                <td colSpan={3}>
                                  <ul>
                                    <li>{addMenu?.outletDiscount}</li>
                                    <li>{addMenu?.sortyfyDiscount}</li>
                                  </ul>
                                </td>
                                <td>{addMenu?.discountAmount}</td>
                              </tr>

                              <tr>
                                <td colSpan={3}>Tax: </td>
                                <td>{addMenu.taxAmount}</td>
                              </tr>
                              <tr>
                                <td colSpan={3}>Paid Amount:</td>
                                <td>{addMenu.netAmount}</td>
                              </tr> */}
                              <tr>
                                <td colSpan={3}>Gross Amount: </td>
                                <td>{addMenu?.grossAmount}</td>
                              </tr>
                              <tr>
                                <td colSpan={3}>
                                  <ul>
                                    <li>{addMenu?.outletDiscount}</li>
                                    <li>
                                      {" "}
                                      Applied {orderDetail?.sortyfyDiscount}%
                                      Sortyfy Discount
                                    </li>
                                  </ul>
                                </td>

                                <td>{addMenu?.discountAmount}</td>
                              </tr>

                              <tr>
                                <td colSpan={3}>Net Amount: </td>
                                <td>{addMenu?.netTotalAmount}</td>
                              </tr>
                              <tr>
                                <td colspan={3}>
                                  <table className="table table-hover text-right thead-light">
                                    <tbody>
                                      {orderDetail?.menu?.taxDetail &&
                                        orderDetail?.menu?.taxDetail?.map(
                                          (menu, index) => (
                                            <tr>
                                              <td>
                                                {menu?.title} {menu?.amount}%
                                              </td>
                                            </tr>
                                          )
                                        )}
                                    </tbody>
                                  </table>
                                </td>
                                <td>
                                  <table className="table table-hover text-right thead-light">
                                    <tbody>
                                      {addMenu?.taxDetail &&
                                        addMenu?.taxDetail?.map(
                                          (menu, index) => (
                                            <tr>
                                              <td>{menu?.charge}</td>
                                            </tr>
                                          )
                                        )}
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td colSpan={3}>Paybale Amount: </td>
                                <td>{addMenu?.paybleTotalAmount}</td>
                              </tr>

                              <tr>
                                <td colSpan={3}>
                                  Redeemed {addMenu?.redeemPoint} Points:{" "}
                                </td>
                                <td>{addMenu?.redeemAmount}</td>
                              </tr>
                              {addMenu?.tableAmount > 0 && (
                                <tr>
                                  <td colSpan={3}>Table Amount (Adjusted): </td>
                                  <td>{addMenu?.tableAmount}</td>
                                </tr>
                              )}

                              <tr>
                                <td colSpan={3}> Sortyfy Commission :</td>
                                <td>{addMenu?.sortyfyCommission}</td>
                              </tr>

                              <tr>
                                <td colSpan={3}> Table Booking :</td>
                                <td>{addMenu?.tableAmount}</td>
                              </tr>

                              <tr>
                                <td colSpan={3}> Tech Assistance Fee:</td>
                                <td>{addMenu?.techAssistance}</td>
                              </tr>

                              <tr>
                                <td colSpan={3}>Platform Fee :</td>
                                <td>{addMenu?.platformCharge}</td>
                              </tr>

                              <tr>
                                <td colSpan={3}>Gateway Fee 1% :</td>
                                <td>{addMenu?.gatewayCharge}</td>
                              </tr>
                              <tr>
                                <td colSpan={3}> Final Outlet Payout :</td>
                                <td>{addMenu?.afterCommission}</td>
                              </tr>
                              {/* <tr>
                                <td colSpan={3}> Final Paid Amount:</td>
                                <td>{addMenu?.netAmount}</td>
                              </tr> */}
                            </tfoot>
                          </table>

                          <table className="table table-hover text-right thead-light">
                            <thead>
                              <tr>
                                <th colSpan={2}>Transaction Details</th>
                                <td colSpan={2}></td>
                              </tr>
                            </thead>
                            <tr>
                              <td colSpan={3}>Transaction Id: </td>
                              <td>{addMenu?.transactionId}</td>
                            </tr>
                            <tr>
                              <td colSpan={3}>Transaction Date: </td>
                              <td>{addMenu?.transactionDate}</td>
                            </tr>
                            <tr>
                              <td colSpan={3}>Transaction Status: </td>
                              <td>{addMenu?.transactionStatus}</td>
                            </tr>
                          </table>
                        </div>
                      );
                    })}
                  </>
                ) : (
                  ""
                )}
              </div>
              {/* <div className="invoice-buttons text-right">
                {" "}
                <Link to="#" className="btn btn-primary mr-2">
                  Print Invoice
                </Link>
                <Link to="#" className="btn btn-primary">
                  Send Invoice
                </Link>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetail;
